const ECG_PATH =
  'M 0 50 L 20 50 L 25 50 L 30 48 L 35 52 L 40 50 ' +
  'L 50 50 L 55 50 L 58 30 L 62 80 L 65 15 L 68 65 L 72 45 L 76 50 ' +
  'L 85 50 L 90 42 L 100 38 L 110 50 L 120 50 ' +
  'L 140 50 L 145 50 L 150 48 L 155 52 L 160 50 ' +
  'L 170 50 L 175 50 L 178 30 L 182 80 L 185 15 L 188 65 L 192 45 L 196 50 ' +
  'L 205 50 L 210 42 L 220 38 L 230 50 L 240 50 ' +
  'L 260 50 L 265 50 L 270 48 L 275 52 L 280 50 ' +
  'L 290 50 L 295 50 L 298 30 L 302 80 L 305 15 L 308 65 L 312 45 L 316 50 ' +
  'L 325 50 L 330 42 L 340 38 L 350 50 L 360 50'

export default function EcgWaveform() {
  return (
    <svg
      viewBox="0 0 360 100"
      className="h-full w-full"
      preserveAspectRatio="none"
      aria-label="ECG waveform showing normal sinus rhythm"
    >
      <path
        d={ECG_PATH}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
